import styled from 'styled-components'

export const Input = styled.input`
  border: 0.2rem solid ${(props) => props.bgColor};
  font-size: 1.1rem;
  margin: 0.5em 0 1.5em;
  padding: 0.7em;
  width: 100%;

  &:focus {
    border-width: 0.25rem;
  }
`

export const Label = styled.label`
  font-weight: bolder;
  color: ${(props) => props.bgColor};
`

export const Error = styled.span`
  color: #e26e2d;
`

export const Submit = styled.button`
  background: none;
  border: 0.2rem solid ${(props) => props.bgColor};
  color: ${(props) => props.bgColor};
  cursor: pointer;
  float: right;
  font-size: 1.1rem;
  font-weight: bolder;
  padding: 0.7em;
  margin: 0;
  text-transform: uppercase;
`
